<template>
<div ref="widgetElement" class="Widget" :style="`grid-column: ${props.column} / span ${props.columns};grid-row: ${props.row} / span ${props.rows};`">
    <div v-if="props.title || $slots.title || props.subtitle || $slots.title" class="Widget-header">
        <div v-if="props.title || $slots.title" class="Widget-title" :class="{ 'placeholder': isLoading }">
            <slot name="title">{{props.title}}</slot>
        </div>

        <div v-if="props.subtitle || $slots.subtitle" class="Widget-subtitle" :class="{ 'placeholder': isLoading }">
            <slot name="subtitle">{{props.subtitle}}</slot>
        </div>
    </div>

    <slot v-if="!isLoading"></slot>
    <div class="Widget-loader" v-else>
        <Loader/> Loading...
    </div>

    <div v-if="$slots.footer" class="Widget-footer">
        <slot name="footer"></slot>
    </div>
</div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps(
{
    title     : { type: String },
    subtitle  : { type: String },
    columns   : { type: [ Number, String ], default: 1 },
    column    : { type: [ Number, String ], default: 'auto' },
    rows      : { type: [ Number, String ], default: 1 },
    row       : { type: [ Number, String ], default: 'auto' },
    isLoading : { type: Boolean, default: false }
});

const widgetElement = ref( null );
</script>

<style lang="scss">
.Widget
{
    --widget-header-height: 0;

    position: relative;

    width: 100%;

    padding: px(24);

    border-radius: 4px;

    background: var(--layout-secondary-background-color);

    box-shadow: var(--elevation-sm-shadow);

    &:has(.Widget-title)    { --widget-header-height: calc( #{fpx(28)} + #{px(24)} ); }
    &:has(.Widget-subtitle) { --widget-header-height: calc( #{fpx(16)} + #{px(24)} ); }
    &:has(.Widget-title)    { --widget-header-height: calc( #{fpx(28)} + #{fpx(16)} + #{px(24)} ); }

    .Widget-header
    {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: px(4);

        width: calc( 100% + #{px(48)} );

        padding: 0 px(24) px(12) px(24);
        margin: px(-12) px(-24) px(16) px(-24);

        border-bottom: 1px solid var(--layout-border-color);

        > .Widget-title
        {
            @include font-title-xs-regular;

            width: 100%;

            display: flex;
            flex-direction: row;
            justify-content: space-between;

            color: var(--primary-text-color);

            &.placeholder
            {
                --placeholder-width: 50%;
                --placeholder-height: var(--font-size);
            }
        }

        > .Widget-subtitle
        {
            @include font-caption-md-regular;

            width: 100%;

            color: var(--secondary-text-color);

            &.placeholder
            {
                --placeholder-width: 25%;
                --placeholder-height: var(--font-size);
            }
        }
    }

    .Widget-loader
    {
        position: absolute;
        top: var(--widget-header-height);
        left: 0;
        width: 100%;
        height: calc(100% - var(--widget-header-height));

        display: inline-flex;
        justify-content: center;
        align-items: center;
        gap: px(8);

        pointer-events: none;
        user-select: none;
    }
}
</style>